/* eslint-disable */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ws_response } from './ws/ws_response';
import { clearRedux } from '../redux/actions/adminAction';

const useWebSocket = (url, functions, accessToken) => {
  const Dispatch = useDispatch();
  const [lastEvent, setLastEvent] = useState(null);

  useEffect(() => {
    if(accessToken !== "" && accessToken !== null ) {

      function connectWebSocket() {
          const socket = new WebSocket(url);
          functions(socket);
          // Set up event handlers
          socket.onmessage = function (evt) {
              const ws_onmessage = JSON.parse(evt.data);
              setLastEvent(ws_onmessage);
              Dispatch(ws_response({evt:evt, ws:socket }));
          };
          socket.onclose = (event) => {
              console.log("websocket close")
              // Reconnect after a delay
              if(localStorage.getItem("access_token") !== null) {
                setTimeout(() => {
                    console.log("Reconnecting...");
                    connectWebSocket();
                }, 1000); // Adjust the delay as needed
              } else {
                  Dispatch(clearRedux());
                  localStorage.clear();
                  localStorage.removeItem("access_token");
              }
          };
          return () => {
            socket.close();
          };
      };
      
      // Initial connection
      connectWebSocket();
    }
  }, [url]);

  return lastEvent;
};

export default useWebSocket;